import 'normalize.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// directives
import directiveCase from './directives/case';
import directiveCleave from './directives/cleave';
// 3rd party plugins
import moment from 'moment';
import { ClientTable } from 'vue-tables-2';

Vue.directive('case', directiveCase);
Vue.directive('cleave', directiveCleave);

// https://matanya.gitbook.io/vue-tables-2/installation#register-the-component-s
Vue.use(ClientTable, {
  customFilters: [
    {
      name: 'filterByDateRange',
      callback: (row, query) => {
        const {
          dateFrom,
          dateTo,
        } = query;
        return moment(row.date).isBetween(dateFrom, dateTo);
      },
    },
  ],
}, true);

import axios from 'axios';
const baseUrl = process.env.NODE_ENV === 'development'
  ? 'https://beta.sfdc-api.teach4taiwan.org/'
  : 'https://sfdc-api.teach4taiwan.org/';
axios.defaults.baseURL = baseUrl;
Vue.prototype.axios = axios;

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.config.productionTip = false;
Vue.use(Loading, {
  canCancel: false,
  color: '#000000',
  loader: 'dots',
  width: 50,
  height: 50,
  backgroundColor: '#ffffff',
  isFullPage: true,
  opacity: 0.3,
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
